<template>
    <div class="shop shop-listing-page">

        <div class="shop-filter-triggers">
            <a class="shop-filter-trigger" href="#" data-ec-toggle="offcanvas" data-ec-target="#shop-sort">
                <svg focusable="false" role="img">
                    <use xlink:href="/build/assets/icons.svg#sort" href="/build/assets/icons.svg#sort"/>
                </svg>
                Sort By
            </a>
            <a class="shop-filter-trigger" href="#" data-ec-toggle="offcanvas" data-ec-target="#shop-filter">
                <svg focusable="false" role="img">
                    <use xlink:href="/build/assets/icons.svg#refine" href="/build/assets/icons.svg#refine"/>
                </svg>
                Refine
            </a>
        </div>

        <div class="container">
            <div class="row justify-content-between shop-main-row">
                <div class="col-3 shop-sidebar">
                    <SpecialFilters
                        :filters="filters"
                        :selected_filters="selected"
                        @update="updateFilters"
                        @clear="clearAllFilters"
                    />
                </div>

                <div class="col-8 shop-main">
                    <ProductGrids
                        :batches="batches"
                        :type="SpecialCard"
                        :is-brochure-mode="isBrochureMode"
                        :show-prices="showPrices"
                        :show-botanical="showBotanical"
                        :default-image="props.defaultImage"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import { ref, watch, onMounted, computed } from 'vue'
import axios from 'axios'
import SpecialCard from "./SpecialCard.vue";
import SpecialFilters from "./SpecialFilters.vue";
import ProductGrids from "./../Product/ProductGrids.vue";

const props = defineProps({
    selectedFilters: Object,
    sort: {
        type: String,
        default: 'title_asc'
    },
    isBrochureMode: {
        type: [Boolean, String],
        default: false
    },
    showPrices: {
        type: [Boolean, String],
        default: true
    },
    showBotanical: {
        type: [Boolean, String],
        default: false
    },
    defaultImage: {
        type: String,
        default: '/images/default.jpg'
    }
})

// Convert string props to boolean
const isBrochureMode = computed(() => {
    return props.isBrochureMode === true || props.isBrochureMode === 'true'
})

const showPrices = computed(() => {
    return props.showPrices === true || props.showPrices === 'true'
})

// Reactive refs
const selected = ref({ ...props.selectedFilters })
const batches = ref([])
const filters = ref([])
const sort = ref(props.sort || 'title_asc')

const fetchBatches = async () => {
    const params = new URLSearchParams()

    Object.entries(selected.value).forEach(([key, values]) => {
        if (Array.isArray(values) && values.length) {
            key = `_ft[${key}]`;
            params.append(key, values.join(','))
        }
    })

    if (sort.value) {
        params.append('sort', sort.value)
    }

    try {
        const { data } = await axios.get(`/api/specials?${params.toString()}`)
        batches.value = data.data || []
    } catch (err) {
        console.error('Error loading filtered batches:', err)
    }
}

const fetchData = async () => {
    try {
        const { data } = await axios.get('/api/specials/filters')
        filters.value = data.filters || []
        batches.value = data.batches || []
    } catch (e) {
        console.error('Failed to load data:', e)
    }
}

const updateFilters = (category, value) => {
    if (category === 'sort') {
        sort.value = value
    } else {
        const index = selected.value[category]?.indexOf(value) ?? -1

        if (index > -1) {
            selected.value[category].splice(index, 1)
        } else {
            selected.value[category] = selected.value[category] || []
            selected.value[category].push(value)
        }
    }

    fetchBatches()
}

const clearAllFilters = () => {
    Object.keys(selected.value).forEach(key => {
        selected.value[key] = []
    })
    fetchBatches()
}

onMounted(async () => {
    await fetchData()
    await fetchBatches()
})
</script>
